<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="Volume Not Found"
      :active.sync="faq_not_found"
    >
      <span
        >Volume record with id: {{ $route.params.programId }} not found.
      </span>
      <span>
        <span>Check </span
        ><router-link to="/program" class="text-inherit underline"
          >All Program</router-link
        >
      </span>
    </vs-alert>

    <vx-card class="mb-base" v-if="item">
      <div class="flex justify-between">
        <div>
          <p class="caption">
            {{ item.category | capitalize }}
          </p>
        </div>

        <div class="caption">
          <p>{{ item.createdAt | datetime }}</p>
        </div>
      </div>
      <h3>{{ item.question }}</h3>
      <p :class="`caption ${getStatus.color}`">
        {{ getStatus.name }}
      </p>
      <div class="mt-3" v-html="item.answer" />
    </vx-card>
  </div>
</template>

<script>
const STATUS_PUBLISHED = {
  0: { name: 'Not Published', color: 'text-danger' },
  1: { name: 'Published', color: 'text-success' },
}

export default {
  data() {
    return {
      item: null,
      faq_not_found: false,
    }
  },

  computed: {
    getStatus() {
      let code
      code = this.item.isPublish ? 1 : 0
      return STATUS_PUBLISHED[code]
    },
  },

  async created() {
    let id = this.$route.params.id
    let res = await this.$store.dispatch('faq/findOne', id)

    if (res.status === 200) {
      this.item = res.data
    } else {
      this.faq_not_found = true
    }
  },
}
</script>
